export default __webpack_public_path__ + "static/media/int_s3.dfbc870c.svg";